import React from 'react';
import serviceImage from '../assets/service1.png';
import ndisLogo from '../assets/ramp-icon-update.png';
import { Link } from 'react-router-dom';
import Fuse from 'fuse.js';
import './News.css';

const News = () => {
  const mainCategories = [
    {
      title: 'NDIS Physiotherapy for Intellectual and Developmental Disorders',
      path: '/news/intellectualanddevelopmental',
    },
    {
      title: 'NDIS Physiotherapy for Neurological Conditions',
      path: '/news/neurologicalconditions',
    },
    {
      title: 'NDIS Physiotherapy for Neuromuscular and Chronic Conditions',
      path: '/news/neuromuscularandchronic',
    },
    {
      title: 'NDIS Physiotherapy for Mental Health Conditions',
      path: '/news/mentalhealth',
    },
    {
      title: 'NDIS Physiotherapy: Key Treatments and Common Questions',
      path: '/news/keytreatmentsandcommonquestions',
    }
  ];

  // Search functionality Commented out for now as it's not working
  // const [searchQuery, setSearchQuery] = useState('');

  // const fuse = new Fuse(articles, {
  //   keys: ['title'],
  //   threshold: 0.3,
  // });

  // const results = searchQuery ? fuse.search(searchQuery) : articles;
  // const filteredArticles = searchQuery ? results.map(result => result.item) : articles;

  // const handleSearchChange = (e) => {
  //   setSearchQuery(e.target.value);
  // };

  return (
    <div className="news-section">
      <div className="news-header">
<h2>NDIS Knowledge</h2>
<p>
  <strong>Stay informed with our latest news, insights, and updates from Ramp Physio and Fitness.</strong> We are dedicated to keeping you in the loop with our newest services, innovative treatment methods, and exclusive fitness programs designed to enhance your well-being. Whether you're seeking expert health tips, guidance on rehabilitation, or information about upcoming community events, you'll find a wealth of resources here. <strong>Explore our articles, join our discussions, and connect with our team to stay empowered on your journey to optimal health and fitness.</strong>
</p>
        {/* Search functionality moved to individual category pages for better content filtering */}
      </div>
      <div className="news-content">
        {/* First Column */}
        <div className="news-column">
          {mainCategories.slice(0, Math.ceil(mainCategories.length / 2)).map((category, index) => (
            <React.Fragment key={index}>
              <div className="news-item">
                <Link to={category.path}>
                  <p>{category.title}</p>
                </Link>
              </div>
              {index < Math.ceil(mainCategories.length / 2) - 1 && (
                <div className="news-item-separator">
                  <p>•</p>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Second Column */}
        <div className="news-column">
          {mainCategories.slice(Math.ceil(mainCategories.length / 2)).map((category, index) => (
            <React.Fragment key={index}>
              <div className="news-item">
                <Link to={category.path}>
                  <p>{category.title}</p>
                </Link>
              </div>
              {index < Math.floor(mainCategories.length / 2) - 1 && (
                <div className="news-item-separator">
                  <p>•</p>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
      <div className="news-item large-return">
        <Link to="/news" className="news-item">
          Return to News
        </Link>
      </div>
    </div>
  );
};

export default News;
